// pages/Caravan.js
import React, { useEffect } from 'react';
import Carousel from '../components/Carousel';

function Caravan() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="caravan-page">
      {/* Hero Section */}
      <div style={{
        padding: '80px 0 40px',
        textAlign: 'center',
        backgroundImage: 'url(/images/cover.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        width: '100%',
        marginLeft: 'calc(-50vw + 50%)',
        minHeight: '400px'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 1
        }}></div>
        <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>

        <style jsx>{`
          @media (max-width: 768px) {
            .caravan-page > div:nth-child(1) {
              padding: 60px 0 30px !important;
              min-height: 300px !important;
            }
            .caravan-page h1 {
              font-size: 2.5rem !important;
            }
            .caravan-page h3 {
              font-size: 1.5rem !important;
            }
          }
        `}</style>
      <img
src="/images/Asset4.png"
alt="Mapping Icon"
style={{
 width: '80px',
 height: '80px',
 objectFit: 'contain'
}}
/>
        <h1 style={{
          fontSize: '3.5rem',
          marginBottom: '20px',
          background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>
          قافلة الحقوق ضد العنف
        </h1>
        <p style={{
          fontSize: '1.3rem',
          lineHeight: '1.9',
          marginBottom: '25px',
          color: 'var(--text-light)'
        }}>
        قافلة وطنية تجوب الجهات ال12 بالمملكة لكسر جدار الصمت
        </p>
        <div style={{
          background: 'var(--secondary-black)',
          padding: '20px 30px',
          borderRadius: '15px',
          borderRight: '4px solid var(--primary-orange)',
          marginBottom: '25px'
        }}>
          <p style={{ fontSize: '1.3rem', marginBottom: '10px' }}>
              <img src="/images/calandarv.png" className="tab-icon3-img" /> <strong>يوم الانطلاق:</strong> الثلاثاء 25 نونبر 2025
          </p>
          <p style={{ fontSize: '1.3rem' }}>
            <img src="/images/location.png" className="tab-icon3-img" /> <strong>عدد المدن:</strong> 12 مدينة
          </p>
        </div>
        </div>
      </div>

      {/* Main Section */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0' }}>
        <div className="container">


          {/* Mission & Objectives */}
          <div style={{ marginBottom: '60px' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              أهداف القافلة
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px',
              marginBottom: '40px'
            }}>
              {[
                {
                  icon: '🤝',
                  title: 'اللقاء والتفاعل',
                  desc: 'اللقاء والتفاعل مع المواطنات والمواطنين حول العنف الرقمي ضد النساء والفتيات'
                },
                {
                  icon: '👂',
                  title: 'الاستماع والإنصات',
                  desc: 'الاستماع إلى المواطنات والمواطنين والناجيات من العنف وإلى شهاداتهن/م بشأن العنف الرقمي ضد النساء والفتيات'
                }
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '30px',
                  borderRadius: '15px',
                  border: '1px solid rgba(255, 107, 53, 0.3)',
                  transition: 'all 0.3s ease',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '3rem', marginBottom: '15px' }}>{item.icon}</div>
                  <h4 style={{ fontSize: '1.4rem', marginBottom: '12px', color: 'var(--primary-orange)' }}>
                    {item.title}
                  </h4>
                  <p style={{ fontSize: '1.05rem', lineHeight: '1.7', color: 'var(--text-light)' }}>
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="section-separator"></div>

          {/* Cities Itinerary */}
          <div style={{ marginTop: '60px', marginBottom: '60px' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '20px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              🗺️ مسار القافلة عبر جهات المملكة
            </h3>
            <p style={{
              textAlign: 'center',
              fontSize: '1.2rem',
              marginBottom: '40px',
              color: 'var(--text-light)'
            }}>
            12 جهة | 16 يوماً | من جنوب المغرب إلى شماله
            </p>

            <div style={{
              display: 'grid',
              gap: '20px'
            }}>
              {[
  { city: 'الداخلة', region: 'جهة الداخلة - وادي الذهب', dates: '27 نونبر', day: 'المحطة 1', icon: '/images/ville/Dakhla.png' },
  { city: 'العيون', region: 'جهة العيون - الساقية الحمراء', dates: '29 نونبر', day: 'المحطة 2', icon: '/images/ville/Laayoun.png' },
  { city: 'كلميم', region: 'جهة كلميم - واد نون', dates: '30 نونبر', day: 'المحطة 3', icon: '/images/ville/Orientale.png' },
  { city: 'أكادير', region: 'جهة سوس - ماسة', dates: '1 دجنبر', day: 'المحطة 4', icon: '/images/ville/Agadir.png' },
  { city: 'بنجرير', region: 'جهة مراكش - آسفي', dates: '2 دجنبر', day: 'المحطة 5', icon: '/images/ville/Marrakech.png' },
  { city: 'ورززات', region: 'جهة درعة - تافيلالت', dates: '3 دجنبر', day: 'المحطة 6', icon: '/images/ville/Tafilalt.png' },
  { city: 'بني ملال', region: 'جهة بني ملال - خنيفرة', dates: '5 دجنبر', day: 'المحطة 7', icon: '/images/ville/Benimellal.png' },
  { city: 'الدار البيضاء', region: 'جهة الدار البيضاء - سطات', dates: '6 دجنبر', day: 'المحطة 8', icon: '/images/ville/Casa.png' },
  { city: 'فاس', region: 'جهة فاس - مكناس', dates: '7 دجنبر', day: 'المحطة 9', icon: '/images/ville/Meknes.png' },
  { city: 'وجدة', region: 'جهة الشرق', dates: '8 دجنبر', day: 'المحطة 10', icon: '/images/ville/Orientale.png' },
  { city: 'الحسيمة', region: 'جهة طنجة - تطوان - الحسيمة', dates: '9 دجنبر', day: 'المحطة 11', icon: '/images/ville/Tanger.png' },
  { city: 'القنيطرة', region: 'جهة الرباط - سلا - القنيطرة', dates: '10 دجنبر', day: 'المحطة 12', icon: '/images/ville/Rabat.png' }
].map((stop, index) => (
                <div key={index} className="city-card" style={{
                  background: index % 2 === 0 ? 'var(--primary-black)' : 'var(--secondary-black)',
                  padding: '25px 30px',
                  borderRadius: '15px',
                  border: '2px solid rgba(255, 107, 53, 0.3)',
                  display: 'grid',
                  gridTemplateColumns: '80px 1fr 200px 150px',
                  alignItems: 'center',
                  gap: '20px',
                  transition: 'all 0.3s ease'
                }}>
                  <div className="city-icon" style={{
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <img
                      src={stop.icon}
                      alt={stop.city}
                      style={{
                        width: '60px',
                        height: '60px',
                        objectFit: 'contain'
                      }}
                    />
                  </div>

                  <div className="city-info">
                    <h4 style={{
                      fontSize: '1.5rem',
                      marginBottom: '5px',
                      color: 'var(--primary-orange)',
                      fontWeight: '700'
                    }}>
                      {stop.city}
                    </h4>
                    <p style={{
                      fontSize: '1.1rem',
                      color: 'var(--text-light)'
                    }}>
                      {stop.region}
                    </p>
                  </div>

                  <div className="city-date" style={{
                    background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
                    padding: '12px 20px',
                    borderRadius: '10px',
                    textAlign: 'center',
                    fontWeight: '700',
                    fontSize: '1.1rem'
                  }}>
                    {stop.dates}
                  </div>

                  <div className="city-day" style={{
                    textAlign: 'center',
                    fontSize: '1rem',
                    color: 'var(--text-light)',
                    fontWeight: '600'
                  }}>
                    {stop.day}
                  </div>
                </div>
              ))}
            </div>

            {/* Responsive Styles */}
            <style jsx>{`
              @media (max-width: 768px) {
                .city-card {
                  grid-template-columns: 1fr !important;
                  padding: 20px 15px !important;
                  gap: 15px !important;
                  text-align: center;
                }

                .city-icon {
                  margin-bottom: 10px;
                }

                .city-icon img {
                  width: 50px !important;
                  height: 50px !important;
                }

                .city-info h4 {
                  font-size: 1.3rem !important;
                  margin-bottom: 8px !important;
                }

                .city-info p {
                  font-size: 1rem !important;
                  line-height: 1.5;
                }

                .city-date {
                  margin: 10px auto !important;
                  max-width: 200px;
                  padding: 10px 15px !important;
                  font-size: 1rem !important;
                }

                .city-day {
                  font-size: 0.95rem !important;
                  padding-top: 5px;
                }
              }

              @media (max-width: 480px) {
                .city-card {
                  padding: 15px 10px !important;
                }

                .city-info h4 {
                  font-size: 1.2rem !important;
                }

                .city-info p {
                  font-size: 0.95rem !important;
                }

                .city-date {
                  font-size: 0.95rem !important;
                  padding: 8px 12px !important;
                }
              }
            `}</style>
          </div>

          <div className="section-separator"></div>




          {/* Call to Action */}
          <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '25px',
              color: 'var(--white)'
            }}>
              نرحب بانضمامكن/م في هذه الرحلة
            </h3>
            <p style={{
              fontSize: '1.3rem',
              marginBottom: '30px',
              color: 'var(--text-light)',
              lineHeight: '1.8'
            }}>
              مرحبا بكن/م في محطات القافلة ال12
            </p>



            <p style={{
              fontSize: '1.2rem',
              marginTop: '30px',
              color: 'var(--text-light)',
              fontStyle: 'italic'
            }}>
              ننتظركن/م للانصات لمقترحاتكن/م وآرائكن/م
            </p>
          </div>
        </div>
      </div>

  <Carousel />
    </div>
  );
}

export default Caravan;
